import { render, staticRenderFns } from "./print_logs.vue?vue&type=template&id=4863ddaf&lang=pug&"
import script from "./print_logs.vue?vue&type=script&lang=js&"
export * from "./print_logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports